export default "__VITE_ASSET__12b3fd8d__"